

<template>
  <vx-card title class="mb-base">
    <div class="mt-5">
      <highcharts class="chart" :options="chartOptions"></highcharts>
    </div>
  </vx-card>
</template>

<script>
import moment from "moment";
import { Chart } from "highcharts-vue";
export default {
  data() {
    return {
      chartOptions: {
        chart: {
          type: "spline"
        },
        exporting: {
          enabled: false,
          buttons: {
            contextButton: {
              menuItems: [
                "printChart",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS"
              ]
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: "Apparent Energy"
        },
        time: {
          timezone: "Asia/Kolkata"
        },
        yAxis: {
          title: {
            text: "VA"
          },
          allowDecimals: true,
          min: 0,
          endOnTick: true
        },
        xAxis: {
          type: "",
          min: 0,
          max: 30,
          startOnTick: true,
          endOnTick: false,
          ordinal: false,
          title: {
            text: "Date"
          },
          tickInterval: null,
          minorGridLineWidth: 0
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 350
              }
            }
          ]
        },
        series: [
          {
            name: "Total Apparent Energy ",
            data: [],
            color: "#87ceeb"
          }
        ]
      }
    };
  },
  components: {
    highcharts: Chart
  },
  methods: {
    apparentEnergyData(data, payload) {
      var payload = payload;
      var self = this;
      self.chartOptions.series[0].data = [];
      var dataRecords = data;
      var data = [];
      var l = dataRecords.length;
      for (var m = 0; m < l; m++) {
        var value = Number(dataRecords[m].tapp);
        var time = dataRecords[m].ts;
        time = moment(time).valueOf();
        data.push([time, value]);
      }
      data = data.sort(function(a, b) {
        return new Date(a[0]) - new Date(b[0]);
      });

      self.chartOptions.xAxis.type = "datetime";
      self.chartOptions.xAxis.min = moment(payload.tsl).valueOf();
      self.chartOptions.xAxis.max = moment(payload.tsh).valueOf();
      self.chartOptions.series[0].data = data;
    }
  }
};
</script>